import "./styles.scss";

import { getPrettyDate } from "components/utils/date";
import { utcToZonedTime } from "date-fns-tz";
import { useMember } from "hooks/member";
import PropTypes from "prop-types";
import React from "react";

import { Tooltip } from "@mui/material";

const CardSendControlCenterHeader = ({ title, subtitle, cardSend, withDate }) => {
  const { timezone } = useMember();

  const { sentDttm, deliverDt } = cardSend;

  const deliverOn = deliverDt && timezone ? getPrettyDate(utcToZonedTime(`${deliverDt}.000Z`, timezone?.timezoneName).toISOString(), true, true, false) : "";
  const sentOn = sentDttm && timezone ? getPrettyDate(utcToZonedTime(`${sentDttm}.000Z`, timezone?.timezoneName).toISOString(), true, true, false) : "";
  const displayDate = sentDttm ? sentOn : deliverOn;

  return (
    <div className="card-send-control-center-header">
      {title && <h4 className="card-send-control-center-title">{title}</h4>}
      {subtitle && <div className="card-send-control-center-subtitle">{subtitle}</div>}
      {withDate && displayDate && (
        <Tooltip disableFocusListener title={timezone?.timezoneDisplayName} arrow placement="top">
          <div className="card-send-control-center-date">{displayDate}</div>
        </Tooltip>
      )}
    </div>
  );
};

CardSendControlCenterHeader.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  cardSend: PropTypes.object.isRequired,
  withDate: PropTypes.bool
};

export default CardSendControlCenterHeader;
